import { useId } from "react";

import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

interface TypeToConfirmProps {
  expected: string;
  value: string;
  onChange: (value: string) => void;
  label: string;
  help?: string;
  placeholder?: string;
  autoFocus?: boolean;
  disabled?: boolean;
}

export function TypeToConfirm({
  expected,
  value,
  onChange,
  label,
  help,
  placeholder,
  autoFocus,
  disabled,
}: TypeToConfirmProps) {
  const id = useId();
  const matches = value === expected;
  return (
    <div className="flex flex-col gap-2">
      <Label htmlFor={id}>{label}</Label>
      <Input
        id={id}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder ?? expected}
        autoFocus={autoFocus}
        disabled={disabled}
        autoComplete="off"
        spellCheck={false}
        aria-invalid={value.length > 0 && !matches}
      />
      {help ? (
        <p className="text-xs text-muted-foreground">{help}</p>
      ) : null}
    </div>
  );
}

// eslint-disable-next-line react-refresh/only-export-components
export function matchesExpected(value: string, expected: string): boolean {
  return value === expected;
}
